import React, { useState, useEffect, useRef } from "react";
import { Chart } from "chart.js";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import "swiper/css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

const Rebalancing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [strategyType, setstrategyType] = useState("");

  const handleSelectStrategyType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setstrategyType(selectedOption.label);
  };
  const riskProfileData = [];
  riskProfileData.push({
    value: 1,
    label: "BUY",
  });
  const [TransactionOptions, setTransactionOptions] = useState(riskProfileData);

  return (
    <div className="pt-4 p-2">
      <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
        <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
          <h1 className="text-lg font-medium mb-2">
            Caprock Model Portfolio - Alternative Growth - Jon Mayer{" "}
          </h1>
        </div>
        <div className="mt-2  rounded-md">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4">
              <label htmlFor="refId" className="mb-1 text-sm text-[#A6A6A6]">
                First Name
              </label>
              <span>John</span>
              <div className="mt-4">
                <label
                  htmlFor="investmentType"
                  className="mb-1 text-sm text-[#A6A6A6]"
                >
                  Last Name
                </label>
                <div>Leen</div>
              </div>
              <label
                htmlFor="investmentType"
                className="mb-1 mt-4 text-sm text-[#A6A6A6]"
              >
                Email
              </label>
              <div>johnleen@gmail.com</div>
            </div>
            {/* center column */}
            <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
              <label htmlFor="investmentManagerFees" className=" mb-1 text-sm">
                <span className="text-[#A6A6A6]">Mobile Number</span>
              </label>
              <div>+64382384929</div>

              <label
                htmlFor="investmentManagerFees"
                className=" mb-1 mt-4 text-sm"
              >
                <span className="text-[#A6A6A6]">Cash Account Balance </span>
              </label>
              <span>$ 1,500.00</span>
              <label
                htmlFor="investmentManagerFees"
                className=" mb-1 mt-4 text-sm"
              >
                <span className="text-[#A6A6A6]">ABN</span>
              </label>
              <div>7777</div>
            </div>
            {/* Left column */}
            <div className="flex lg:pt-4 pt-0 flex-col px-4">
              <label htmlFor="investmentManagerFees" className=" mb-1 text-sm">
                <span className="text-[#A6A6A6]"> Date of Investment</span>
              </label>
              <div>23/03/2024</div>
              <label
                htmlFor="investmentManagerFees"
                className=" mb-1 mt-4 text-sm"
              >
                <span className="text-[#A6A6A6]">
                  Initial Investment Amount
                </span>
              </label>
              <div>$ 100,500.00</div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white p-6 rounded-lg shadow mt-4">
        <div className="flex justify-between items-center border-b mb-4">
          <h3 className="text-md font-semibold mb-2 ">Portfolio Breakdown</h3>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse font-medium w-full text-xs">
            <thead>
              <tr className="bg-[#ECFFEE] text-[#005A9C]">
                <th className="border  text-left px-4 py-2">ASX Code</th>
                <th className="border text-left px-4 py-2">Security Price</th>
                <th className="border text-left px-4 py-2">
                  Capital Allocation
                </th>
                <th className="border text-left px-4 py-2">SAA</th>
                <th className="border text-left px-4 py-2">Current W%</th>
                <th className="border text-left px-4 py-2">Capital Change</th>
                <th className="border text-left px-4 py-2">Suggested Change</th>
              </tr>
            </thead>
            <tbody>
              <tr key={1} className={`text-[#black]`}>
                <td className="border bg-[#ECFAFF] px-4 py-2">AAA</td>
                <td className="border px-4 py-2">146</td>
                <td className="border px-4 py-2">4,570.00</td>
                <td className="border px-4 py-2">12%</td>
                <td className="border px-4 py-2">2%</td>
                <td className="border px-4 py-2">-4,570.00</td>
                <td className="border px-4 py-2">
                  <span
                    className={`w-30 h-8 rounded-xl text-center px-4 py-2 flex justify-center items-center focus:outline-none border-2 border-[#FF5050] text-[#FF5050]`}
                  >
                    Buy 4 Shares
                  </span>
                </td>
              </tr>
              <React.Fragment>
                <tr key={1} className={`text-[#black]`}>
                  <td className="border px-4 py-2 text-[#34C046]`">CASH</td>
                  <td className="border px-4 py-2">-</td>
                  <td className="border px-4 py-2">4,570.00</td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                </tr>
                <tr key={1} className={`text-[#black]`}>
                  <td className="border px-4 py-2 font-bold text-[#005A9C]">
                    Total Portfolio Value
                  </td>
                  <td className="border px-4 py-2">-</td>
                  <td className="border px-4 py-2 font-bold text-[#005A9C]">
                    4,570.00
                  </td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                  <td className="border px-4 py-2"></td>
                </tr>
              </React.Fragment>
            </tbody>
          </table>
        </div>

        {/* rebalancing section */}
        <div className="p-6 mt-6 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md">
          <div className="flex items-center border-b border-[#DFD7C1] space-x-2 pt-2 px-6">
            <h1 className="text-lg font-semibold mb-2 text-black text-center">
              Rebalance
            </h1>
          </div>

          <div className="grid px-4 grid-cols-1 border-b border-[#DFD7C1] pb-4 md:grid-cols-3 gap-6">
            {/* Left Column */}
            <div className="space-y-4 pt-4 px-4">
              <div>
                <label htmlFor="code" className="mb-1 text-sm text-labelColour">
                  ASX
                </label>
                <input
                  id="code"
                  type="text"
                  className="bg-[#F9F9F9] border block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="CT0291288"
                />
                <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                  <span className="text-sm text-black font-medium">
                    Creatorhhhhh Name
                  </span>
                </div>
              </div>
            </div>

            {/* Center Column */}
            <div className="space-y-4 lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Dropdown
                    label="Transaction"
                    options={TransactionOptions}
                    onSelect={handleSelectStrategyType}
                  />
                </div>

                {/* No of Shares Input */}
                <div>
                  <label className="block text-sm text-[#464646]">
                    No of shares
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={2}
                      disabled={true}
                      className="p-2 mt-2 text-black w-full font-medium border border-gray-300 bg-white rounded-md text-md"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4 px-4 pt-4">
              <div>
                <label htmlFor="smaFees" className="block mb-1 text-sm">
                  <span className="text-labelColour">Creator ID</span>
                </label>
                <div className="relative">
                  <input
                    type="number"
                    value={3}
                    className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                  />
                </div>
                <div className="flex flex-wrap bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                  <span className="text-sm text-labelColour font-medium whitespace-nowrap">
                    Creator Name:
                  </span>
                  <img
                    src="/valid.svg"
                    alt="User Icon"
                    className="w-4 h-4 flex-shrink-0"
                  />
                  <span className="font-medium text-black">Anfas Pervez</span>
                </div>
              </div>
            </div>
          </div>

          {/* Button Container */}
          <div className="flex justify-end px-4 mt-4">
            <button className="bg-black text-white px-4 py-2 text-sm rounded-full whitespace-nowrap">
              Execute Transaction
            </button>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between mt-6 px-8 py-4 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md space-y-4 md:space-y-0">
          {/* Text Section */}
          <div className="text-center md:text-left flex-1">
            <span className="block text-sm md:text-md font-medium text-black">
              Auto rebalance will perform all buy and sell transactions needed
              to rebalance the portfolio
            </span>
          </div>

          {/* Button Section */}
          <div className="text-center md:text-right">
            <button
              onClick={() => console.log("Download triggered")}
              className="flex items-center justify-center space-x-2 bg-black text-white font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200 hover:text-black"
            >
              <span>Auto Rebalance</span>
            </button>
          </div>
        </div>

        <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
          <div className="flex items-center justify-start w-full space-x-4">
            <div
              onClick={() => navigate("/investment-request-list")}
              className="flex items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
            >
              <img
                src="/white-arrow-back.svg"
                alt="Back Icon"
                className="w-4 h-4"
              />
              <span>Back</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rebalancing;
